import React from 'react';
import { ToggleButton, ToggleButtonGroup, Form } from 'react-bootstrap';

/**
 * ServiceTypeToggle — basic vs deep clean selector.
 *
 * Decision #3: subscription packages are basic-only; deep clean is per-visit.
 * Used in CreateServiceRequest's per_visit billing path.
 */
const ServiceTypeToggle = ({ value, onChange, disabled = false, label = 'نوع الخدمة' }) => {
  return (
    <Form.Group className="mb-3" dir="rtl">
      <Form.Label style={{ fontWeight: 600, fontSize: '0.88rem' }}>{label}</Form.Label>
      <ToggleButtonGroup
        type="radio"
        name="serviceType"
        value={value || 'basic'}
        onChange={onChange}
        className="d-flex"
      >
        <ToggleButton
          id="service-type-basic"
          value="basic"
          variant={value === 'basic' ? 'primary' : 'outline-secondary'}
          disabled={disabled}
          style={value === 'basic'
            ? { background: '#471396', borderColor: '#471396', flex: 1 }
            : { flex: 1 }}
        >
          نظافة عادية
        </ToggleButton>
        <ToggleButton
          id="service-type-deep"
          value="deep"
          variant={value === 'deep' ? 'primary' : 'outline-secondary'}
          disabled={disabled}
          style={value === 'deep'
            ? { background: '#471396', borderColor: '#471396', flex: 1 }
            : { flex: 1 }}
        >
          نظافة عميقة
        </ToggleButton>
      </ToggleButtonGroup>
    </Form.Group>
  );
};

export default ServiceTypeToggle;
